import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { MenuModel } from 'app/models/menu.model';
import { GridService } from './grid.service';
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { NotificationType } from 'angular2-notifications';
import { Subscription } from 'rxjs';
import { IMqttMessage, IMqttServiceOptions, MQTT_SERVICE_OPTIONS, MqttModule, MqttService } from 'ngx-mqtt';
import { IClientSubscribeOptions } from 'mqtt-browser';
import { environment } from 'environments/environment';
import { FormService } from './form.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { DrakeViewConfig } from 'app/models/permissions';
import { DrakeCustomScriptsService } from './drake-custom-scripts.service';
import { DrakeOption } from 'app/models/interfaces';




@Injectable({
  providedIn: 'root',
})
export class DrakeSharedService {
  public currentPageData: any;
  public currentBaseData: any;
  public mainRecord: any;
  public notificationQueue: Array<any> = [];
  public drakeBotMessages: string[] = [];

  public editableSubject = new BehaviorSubject<DrakeViewConfig>({ canInsert: false, canEdit: false, canDelete: false, canExport: false, canView: false, canAi:false, progressiveLoading: 0, exportFilename: null });
  public messageReceived: Subject<string> = new Subject<string>();


  public addRowSubject = new BehaviorSubject<void>(null);
  public removeRowSubject = new BehaviorSubject<void>(null);
  public saveScopeFormSubject = new Subject<boolean>();
  public saveScopeFormSubjectDraft = new Subject<boolean>();
  public approveScopeFormSubject = new Subject<boolean>();
  public cloneScopeFormSubject = new Subject<boolean>();
  public saveQuickEditSubject = new Subject<void>();
  public exportSubject = new Subject<void>();
  public valueChangedSubject = new BehaviorSubject<any>(null);
  public messageSubject: Subject<{ type: string, content: any, timestamp: string, notes: string }> = new Subject<{ type: string, content: any, timestamp: string, notes: string }>();
  public changeStatusSubject: Subject<{ type: string, content: any, timestamp: string}> = new Subject<{ type: string, content: any, timestamp: string }>();
  public requestSubject: Subject<any> = new Subject<any>();
  public baseData$ = new BehaviorSubject<any>({});
  public baseDataLoaded: Subject<any> = new Subject<any>();
  public drpOptions:Record<string,DrakeOption[]>={};

  private _drakeScripts: DrakeCustomScriptsService | null = null;
  private postMessageSubject = new Subject<any>();
  public postMessages$ = this.postMessageSubject.asObservable();

  public ws = {
    client: null,
    connectionState: false,
    subscriptions: new Array<Subscription | undefined>
  };


  private connection: IMqttServiceOptions = {
    hostname: environment.mqtt.address,
    port: environment.mqtt.port,
    path: "/mqtt",
    clean: true, // Retain session
    connectTimeout: 4000, // Timeout period
    reconnectPeriod: 4000, // Reconnect period
    clientId: 'DrakeClient',
    // Authentication information
    protocol: environment.mqtt.protocol as ('ws' | 'wss')
  }

  constructor(
    private router: Router,
    private notificationsService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private gridservice: GridService,
    private injector: Injector) {

      window.addEventListener('postMessage', (event:any) => {
      //if (event.origin !== 'https://dominio-autorizzato.com') return;
      this.postMessageSubject.next(event.data);
    });
  }

  get drakeScripts(): DrakeCustomScriptsService {
    if (!this._drakeScripts) {
      this._drakeScripts = this.injector.get(DrakeCustomScriptsService);
    }
    return this._drakeScripts;
  }

  public toolbarActions: any = {
    ADVANCEDSEARCH: () => {
      this.navigateWithBreadCrumb([`/d/${this.currentPageData.pagTitle}.DEFAULT/filter`]);

    },
    NEW: () => {
      this.navigateWithBreadCrumb([`${this.router.url.split('/v/')[0].split('?')[0]}/f`]);

    },
    QUICKEDIT: () => {
      this.navigateWithBreadCrumb([`${location.pathname}/q`])
    },
    SAVE: (redirect) => {
      if (redirect === true)
        this.saveScopeFormSubjectDraft.next(true);
      else
        this.saveScopeFormSubjectDraft.next(false);
    },
    SAVEDRAFT: (redirect) => {
      if (redirect === true)
        this.saveScopeFormSubjectDraft.next(true);
      else
        this.saveScopeFormSubjectDraft.next(false);
    },
    SAVECLOSE: () => {
      this.toolbarActions.SAVE(true);
    },
    PRINTPDF: () => {
      const currentUrl = this.router.url;

      // Controlla se l'URL corrente termina con "/p"
      if (currentUrl.endsWith('/p')) {
        return; // Non fare nulla se l'URL termina già con "/p"
      }

      const newUrl = `${currentUrl}/p`;
      this.navigateWithBreadCrumb([newUrl]);
    },
    CLOSEFORM: () => {
      this.router.navigateByUrl(this.getLastBreadcrumb(), { state: { skipBreadcrumb: true } });

    },
    CLONE: (redirect) => {
      /*
      var scopes = Object.keys(this.currentBaseData);
      scopes.forEach(s => {
        var records = Object.keys(this.currentBaseData[s]);
        records.forEach((r) => {
          console.log(s + " - " + r);

          this.gridservice.cloneScopeData(s, "UPSERT", this.currentBaseData[s][r]).subscribe((result: any) => {
            console.log(s + " - " + r, result);
            //var notification = this.translocoPipe.transform("notification.success.toolbar.clone");
            //this.showTemporaryNotification(notification, 'success');
            this.showTemporaryNotification(`Clonazione effettuata correttamente`, 'success');
            if (redirect)
              this.toolbarActions.CLOSEFORM();
            else if (r == "#NEWID#")
              this.router.navigate([`${location.pathname}/${result.data[0].q._id}`], { state: { skipBreadcrumb: true } })

          },
            (err: any) => {
              console.log(err)
              //var notification = this.translocoPipe.transform("notification.error.toolbar.clone");
              //this.showTemporaryNotification(notification, 'error');
              this.showTemporaryNotification(`Si è verificato un errore durante la clonazione.`, 'error');

            });
        });
      })*/
      this.cloneScopeFormSubject.next(redirect);

    },

    SELECTVIEW: (val: any) => {
      console.log('change view', val)
      var scope = location.pathname.split('/')[2];
      var url = `/d/${scope}/v/${val}`;
      console.log('navigating', url)
      this.router.navigate([url])
    },
    SELECTCOMPONENT: (val: any) => {
      console.log('change view', val)
      var scope = location.pathname.split('/')[2];
      var view = location.pathname.split('/')[4] || scope + ".DEFAULT";
      var url = `/d/${scope}/v/${view}/c/${val}`;
      if (val == scope + ".DEFAULT")
        url = `/d/${scope}`;
      console.log('navigating', url)
      this.router.navigate([url])
    },

    CHANGEVALUE: (value: any, field: string) => {
      if (value) {
        console.log('change stato', value)
        this.mainRecord[field] = value;
        this.valueChangedSubject.next({ field, value });
        this.toolbarActions.SAVE(false);
      }
    },


    APPROVE: () => {
      //debugger;
      var value = 'APPROVED';
      var field = 'StatoAnagrafica';
      if (value) {
        console.log('change stato', value)
        this.mainRecord[field] = value;
        this.valueChangedSubject.next({ field, value });
        this.approveScopeFormSubject.next(false);
      }

    },
    REJECT: () => {
      var value = 'REJECTED';
      var field = 'StatoAnagrafica';
      if (value) {
        console.log('change stato', value)
        this.mainRecord[field] = value;
        this.valueChangedSubject.next({ field, value });
        this.approveScopeFormSubject.next(false);
      }

    },
    ADDROW: () => {
      this.addRowSubject.next();
    },
    REMOVEROW: () => {
      this.removeRowSubject.next();
    },
    SAVEQUICKEDIT: () => {
      this.saveQuickEditSubject.next();
    },
    EXPORTEXCEL: () => {
      this.exportSubject.next();
    },
    SEARCH: (action: any, valueInput: string, notFoundMessage: string) => {
      let searchObj = JSON.parse(action.actDrpUrl);
      let replaced = searchObj.filter.replace(/{search}/g, valueInput);
      //console.log("replaced", replaced);

      const requestData = {
        ViewCode: "",
        Filter: replaced,
        Sort: "",
        Page: 0,
        PageSize: 0,
        Language: "",
        Cache: false,
        ExtraData: {}
      };

      let loadedData = this.gridservice.getScopeData(searchObj.scope, "READ", requestData);
      console.log("ecco i dati caricati", loadedData);

      loadedData.subscribe(
        (response) => {
          if (response.data.length == 1) {
            //console.log("response.data", response.data);
            const actUrl = "d/" + searchObj.scope + "/f/" + response.data[0]._id + (searchObj.template ? "/t/" + searchObj.template : '');
            this.router.navigateByUrl(actUrl);
          }
          else if (response.data.length > 1) {

            const actUrl = "d/" + searchObj.scope + "?filter=" + replaced + (searchObj.template ? "&template=" + searchObj.template : '');
            this.router.navigateByUrl(actUrl);
          } else {
            console.log("nessun risultato");
            var notification = notFoundMessage;
            this.showTemporaryNotification(notification, 'info');
          }
        },
        (error: any) => {
          console.error('Errore:', error);
        },
      );

    },
    CUSTOMSCRIPT: (action: any, value: string) => {

      var data = JSON.parse(action.actDrpUrl.replace(/\{value\}/g, value))
      this.drakeScripts[data.fnName](data.fnArgs);
    }

  }

  navigateWithBreadCrumb(url: string[], extraParams?: NavigationExtras | null) {

    this.router.navigate(url, { ...extraParams || {}, state: { previousUrl: location.href.split(location.host)[1] } });
  }

  addBreadcrumbUrl(url?: string) {

    if (!history.state?.skipBreadcrumb) {
      if (!url)
        url = history.state?.previousUrl;

      let sessionUrls = this.getBreadcrumbs();
      if (!sessionUrls.length || sessionUrls[sessionUrls.length - 1] != url)
        sessionUrls.push(url);
      sessionStorage.breadcrumbs = JSON.stringify(sessionUrls);
    }
  }

  getBreadcrumbs() {

    return sessionStorage.breadcrumbs ? JSON.parse(sessionStorage.breadcrumbs) : [];
  }

  getLastBreadcrumb() {

    let sessionUrls = this.getBreadcrumbs();
    let lastUrl = sessionUrls.length > 0 ? sessionUrls.pop() : '/'
    sessionStorage.breadcrumbs = JSON.stringify(sessionUrls);
    return lastUrl;
  }
  resetBreadcrumbs() {

    sessionStorage.breadcrumbs = '[]';
  }
  editItem(scope: string, id: string, editable: boolean = true, template: string = null) {
    const encodedId = encodeURIComponent(id);
    this.navigateWithBreadCrumb([`/d/${scope}/f/${encodedId}` + (template ? '/t/' + template : '')], { skipLocationChange: false, onSameUrlNavigation: 'reload', state: { previousUrl: location.href.split(location.host)[1] } });
  }

  createWsConnection() {
    if (environment.mqtt.enable && !this.ws?.connectionState) {
      debugger;
      this.ws.client = new MqttService(this.connection);

      try {
        this.ws.client?.connect(this.connection)
      } catch (error) {
        console.log('mqtt.connect error', error);
      }
      this.ws.client?.onConnect.subscribe(() => {
        this.ws.connectionState = true
        console.log('Connection succeeded!');
        /*this.ws.subscriptions.push(this.ws.client?.observe("#", { qos: 0 } as IClientSubscribeOptions).subscribe((message: IMqttMessage) => {
          console.log('Subscribe to topics res', message.payload.toString())
        }));*/

        this.ws.subscriptions.forEach(x => {
          x.unsubscribe();
        });

        //AI
        this.ws.subscriptions.push(
          this.ws.client?.observe(JSON.parse(localStorage.getItem("user")).id + "/DRAKEAI/SCOPE/+/USERRESPONSE", { qos: 0 } as IClientSubscribeOptions)
            .subscribe((message: IMqttMessage) => {
              //console.log('Message from AI:', message.payload.toString());
            })
        );
        this.ws.subscriptions.push(
          this.ws.client?.observe(JSON.parse(localStorage.getItem("user")).id + "/DRAKEAI/GENERAL/USERRESPONSE", { qos: 0 } as IClientSubscribeOptions)
            .subscribe((message: IMqttMessage) => {
              //console.log('Message from AI:', message.payload.toString());
            })
        );
         this.ws.subscriptions.push(
          this.ws.client?.observe(JSON.parse(localStorage.getItem("user")).id + "/NOTIFICATIONS", { qos: 0 } as IClientSubscribeOptions)
            .subscribe((message: IMqttMessage) => {
              console.log('Message from Notifications:', message.payload.toString());
            })
        );
        this.ws.subscriptions.push(
          this.ws.client?.observe(JSON.parse(localStorage.getItem("user")).id + "/DRAKEAI/GENERAL/WFUPDATE", { qos: 0 } as IClientSubscribeOptions)
            .subscribe((message: IMqttMessage) => {
              //console.log('Message from AI:', message.payload.toString());
            })
        );



      });


      this.ws.client?.onError.subscribe((error: any) => {
        this.ws.connectionState = false
        console.log('Connection failed', error);
      });
      this.ws.client?.onMessage.subscribe((packet: any) => {
        console.log(`Received message ${packet.payload.toString()} from topic ${packet.topic}`)
        
        var operation = packet.topic.split("/");
        if (operation
          && operation.includes("NOTIFICATIONS")
          && operation.includes(JSON.parse(localStorage.getItem("user")).id)) {
          this.notificationsService.getNofications().subscribe(x => this.showTemporaryNotification(`Hai ricevuto una notifica: ${x.at(-1).Title}`, 'info', x.at(-1)));
        } else if (operation
          && operation.includes("DRAKEBOT")
          && operation.includes("RESPONSE")
          && operation.includes(JSON.parse(localStorage.getItem("user")).id)) {

          try {
            const messageContent = JSON.parse(packet.payload.toString());
            if (
              messageContent.type === "PARTIAL" &&
              messageContent.content !== null &&
              messageContent.content !== ""
            ) {

              this.drakeBotMessages.push(messageContent.content);
              this.messageReceived.next(messageContent.content);
            }
          } catch (error) {
            console.log('Errore nel parsing del messaggio:', error);
          }
        } else if (operation
          && operation.includes("DRAKEAI")
          && operation.includes("USERRESPONSE")
          && operation.includes(JSON.parse(localStorage.getItem("user")).id)) {


          try {
            const messageContent = JSON.parse(packet.payload.toString());
            /*if (
              messageContent.content !== null &&
              messageContent.content !== ""
            ) {*/

            this.messageSubject.next(messageContent);
            //}
          } catch (error) {
            console.log('Errore nel parsing del messaggio:', error);
          }
        }
        else if (operation
          && operation.includes("DRAKEAI")
          && operation.includes("WFUPDATE")
          && operation.includes(JSON.parse(localStorage.getItem("user")).id)) {

          try {
            const messageContent = JSON.parse(packet.payload.toString());
            /*if (
              messageContent.content !== null &&
              messageContent.content !== ""
            ) {*/

            this.changeStatusSubject.next(messageContent);
            //}
          } catch (error) {
            console.log('Errore nel parsing del messaggio:', error);
          }
        }
        else if (operation
          && operation.includes("WORKFLOW")
          && operation.includes("REQUEST")
          && operation.includes(JSON.parse(localStorage.getItem("user")).id)) {


          try {
            const messageContent = JSON.parse(packet.payload.toString());
            /*if (
              messageContent.content !== null &&
              messageContent.content !== ""
            ) {*/

            this.requestSubject.next(messageContent);
            //}
          } catch (error) {
            console.log('Errore nel parsing del messaggio:', error);
          }
        }

      });
    }
  }

  destroyWsConnection() {
    try {
      this.ws.client?.disconnect(true)
      this.ws.connectionState = false
      console.log('Successfully disconnected!')
    } catch (error: any) {
      console.log('Disconnect failed', error.toString())
    }
  }

  public showTemporaryNotification(message: string, type: string, notification: any = null): void {
    const notificationType: NotificationType = type as NotificationType;
    if (notification) {
      this.notificationQueue.push({ message, title: '', notificationType, notification })
    }
    else
      this.notificationQueue.push({ message, title: '', notificationType })
  }
}
